import { setCartId } from "@utils/api"
import { getCookie } from "@utils/index"
import * as React from "react"

export default function useCartIdCookieSync(checkoutId?: null | string) {
  React.useEffect(() => {
    if (!checkoutId) {
      return
    }

    const current = getCookie("uag_cart_id")

    if (current !== checkoutId) {
      // ignore result; fire-and-forget
      setCartId(checkoutId).catch(() => {})
    }
  }, [checkoutId])
}
